export const isLast = (arr, index) => (arr.length == index ? true : false);

export const formatDate = date =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;



// WEBPACK FOOTER //
// ./src/util.js